// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* INI BAGIAN TERPENTING */
.modal-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  position: relative;
  
  /* Auto follow content size */
  width: auto;
  height: auto;

  /* Tapi tetap dibatasi */
  max-width: 90vw;
  max-height: 90vh;

  display: flex;
  flex-direction: column;
  overflow: auto;
}

/* Close Button */
.modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/component/crop_image/imageModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;;EAElB,6BAA6B;EAC7B,WAAW;EACX,YAAY;;EAEZ,wBAAwB;EACxB,eAAe;EACf,gBAAgB;;EAEhB,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB","sourcesContent":[".modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0,0,0,0.6);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 9999;\r\n}\r\n\r\n/* INI BAGIAN TERPENTING */\r\n.modal-content {\r\n  background: #fff;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  position: relative;\r\n  \r\n  /* Auto follow content size */\r\n  width: auto;\r\n  height: auto;\r\n\r\n  /* Tapi tetap dibatasi */\r\n  max-width: 90vw;\r\n  max-height: 90vh;\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: auto;\r\n}\r\n\r\n/* Close Button */\r\n.modal-close {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  background: none;\r\n  border: none;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
